import { FC, useMemo } from "react";
import styled from "styled-components";

import {
  DATA_E2E_KEY,
  IStyledAttributes,
  NO_VALUE_DISPLAY,
} from "@ryde/shared";

import { FramerTooltip } from "../../common";
import { useDecorateWithMark } from "../../utils";
import { IRenderColumnTemplate } from "./_core";

export const PlainTextCellStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "plain-text-cell-wrapper",
})`
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const PlainTextCellTemplate: FC<IRenderColumnTemplate> = ({
  id,
  value,
  valueTranslated,
  name,
  formFieldTypeId,
  e2eData,
}) => {
  const { decorateValue } = useDecorateWithMark();

  const valueComputed = useMemo(() => {
    const baseValue = String(valueTranslated || value);
    return decorateValue(baseValue);
  }, [valueTranslated, value, decorateValue]);

  const tooltipContent = useMemo(() => {
    return String(valueTranslated || value);
  }, [valueTranslated, value]);

  return (
    <FramerTooltip content={tooltipContent} rtlStrippedBottomLeftPlacement>
      <PlainTextCellStyled
        data-e2e-id={`${name}_fieldid_${formFieldTypeId}`}
        data-e2e-value={value}
        data-e2e-template={"plain-text-cell"}
        data-e2e-custom={e2eData}
        data-e2e-custom-field-id={id}
      >
        <span>{valueComputed || NO_VALUE_DISPLAY}</span>
      </PlainTextCellStyled>
    </FramerTooltip>
  );
};
